import { render, staticRenderFns } from "./ui-label.vue?vue&type=template&id=11c42fdc&scoped=true"
import script from "./ui-label.vue?vue&type=script&lang=js"
export * from "./ui-label.vue?vue&type=script&lang=js"
import style0 from "./ui-label.vue?vue&type=style&index=0&id=11c42fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c42fdc",
  null
  
)

export default component.exports